import React, { useState, Suspense } from 'react';
import { Button } from 'framework/ui/mui-builder';

const LeaveDetailsModal = React.lazy(() => import('../modal/LeaveDetailsModal'));

interface ViewDetailsButtonProps {
  leaveId: string | number;
}

const ViewDetailsButton: React.FC<ViewDetailsButtonProps> = ({ leaveId }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button
        size="small"
        onClick={handleOpenModal}
        variant="outlined"
        sx={{
          fontSize: '0.75rem',
          padding: '2px 8px',
        }}
      >
        View details
      </Button>
      {modalOpen && (
        <Suspense fallback={<div>Loading...</div>}>
          <LeaveDetailsModal isOpen={modalOpen} onClose={handleCloseModal} leaveId={String(leaveId)} />
        </Suspense>
      )}
    </>
  );
};

export default ViewDetailsButton;
